module.exports = __webpack_public_path__ + "img/logo-atmo.fb5953da.jpg";